/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IProductSheetViewProps } from './product-sheet';

export default (props: IProductSheetViewProps) => {
    const { resources, onDownloadProductSheet } = props;
    return (
        <div className='row product-sheet-container'>
            <button className='msc-btn' onClick={onDownloadProductSheet}>
                <span>{resources.productSheetButtonText}</span>
                <i className='fa-regular fa-file-pdf'></i>
            </button>
        </div>
    );
};
